import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { buyerNotifications } from '../data/content';
const MINUTES = [2, 3, 4, 6, 7, 9, 11, 13];
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let timeouts: number[] = [];
    const cycle = () => {
      setVisible(true);
      timeouts.push(window.setTimeout(() => {
        setVisible(false);
        timeouts.push(window.setTimeout(() => {
          setIndex(prev => (prev + 1) % buyerNotifications.length);
          cycle();
        }, 9000));
      }, 6000));
    };
    const start = window.setTimeout(cycle, 6000);
    timeouts.push(start);
    return () => {
      timeouts.forEach(id => window.clearTimeout(id));
    };
  }, [dismissed]);
  const buyer = buyerNotifications[index];
  const minutesAgo = MINUTES[index % MINUTES.length];
  return <AnimatePresence data-id="element-41" data-mp="1164o26qe2u2c">
      {visible && !dismissed ? <motion.aside key={buyer.name} initial={{
      opacity: 0,
      y: 16,
      scale: 0.97
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 16,
      scale: 0.97
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-24 left-3 right-3 z-50 mx-auto max-w-[22rem] rounded-2xl border border-white/10 bg-white px-3 py-3 shadow-[0_20px_45px_-18px_rgba(0,0,0,0.6)] sm:left-5 sm:right-auto sm:bottom-28" aria-live="polite" data-id="element-42" data-mp="1fvixfetytbhq">
          <div className="flex items-start gap-3" data-id="element-43" data-mp="s56eza13fwcw">
            <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-emerald-100" data-id="element-44" data-mp="s8khci9rc5kc">
              <CheckCircle2Icon className="h-5 w-5 text-emerald-600" aria-hidden="true" data-id="element-45" data-mp="23lmypfjokz5k" />
            </span>
            <div className="min-w-0" data-id="element-46" data-mp="2aobfst9bmaz5">
              <p className="text-sm font-bold leading-snug text-navy-900" data-id="element-47" data-mp="2fne8de846oq8">
                {buyer.name}
              </p>
              <p className="text-[0.78rem] leading-snug text-slate-600" data-id="element-48" data-mp="2kmhgx8nazd2y">
                just purchased the{' '}
                <span className="font-semibold text-navy-800" data-id="element-49" data-mp="2pkiy1o1652bs">
                  Clinical Route for Erectile Dysfunction™
                </span>
              </p>
              <p className="mt-1 text-[0.7rem] font-medium uppercase tracking-[0.08em] text-slate-400" data-id="element-50" data-mp="1wwwv8hzrm1pz">
                {buyer.place} · {minutesAgo} min ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} className="ml-auto -mr-1 -mt-1 rounded-lg p-1 text-slate-400 transition-colors duration-150 ease-out hover:bg-slate-100 hover:text-slate-600" aria-label="Dismiss purchase notifications" data-id="element-51" data-mp="26mzmodr8n7m7">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-52" data-mp="3rh86vbb94tnf" />
            </button>
          </div>
        </motion.aside> : null}
    </AnimatePresence>;
}